function clearPersistedPageState(key = null) {
  return localStorage.removeItem(key ?? window.location.pathname)
}

export default clearPersistedPageState
